import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { database } from "../services/firebaseConfig"; // adjust path to your firebase.js
import { FaCalendarAlt } from "react-icons/fa";

const Content = () => {
    const [bloodData, setBloodData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBloodData = async () => {
            try {
                const q = query(collection(database, "BloodAvailable"), orderBy("bloodgroup", "asc"));
                const snapshot = await getDocs(q);
                const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
                setBloodData(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBloodData();
    }, []);

    const today = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });

    // 👉 Calculate totals
    const totalWB = bloodData.reduce((sum, item) => sum + (parseInt(item.wb) || 0), 0);
    const totalPCVLR = bloodData.reduce((sum, item) => sum + (parseInt(item.pcvlr) || 0), 0);
    const totalNAT = bloodData.reduce((sum, item) => sum + (parseInt(item.nat) || 0), 0);
    const totalOverall = bloodData.reduce((sum, item) => sum + (parseInt(item.total) || 0), 0);

    return (
        <div className="container py-5 pb-5">
            {/* Header with calendar */}
            <div className="mb-3 data-table">
                <FaCalendarAlt className="text-danger me-2" />
                <span>Today ( {today} )</span>
            </div>

            {/* Table */}
            {loading ? (
                <p>Loading data...</p>
            ) : (
                <div className="table-responsive">
                    <table className="table table-bordered table-striped text-center align-middle">
                        <thead className="table-danger">
                            <tr>
                                <th>BLOOD</th>
                                <th>WB</th>
                                <th>PVC + LC</th>
                                <th>NAT</th>
                                <th>TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bloodData.length > 0 ? (
                                <>
                                    {bloodData.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.bloodgroup}</td>
                                            <td>{item.wb || 0}</td>
                                            <td>{item.pcvlr || 0}</td>
                                            <td>{item.nat || 0}</td>
                                            <td>{item.total || 0}</td>
                                        </tr>
                                    ))}
                                    {/* Totals Row */}
                                    <tr className="fw-bold table-warning">
                                        <td>Total</td>
                                        <td>{totalWB}</td>
                                        <td>{totalPCVLR}</td>
                                        <td>{totalNAT}</td>
                                        <td>{totalOverall}</td>
                                    </tr>
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Content;
